import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reelInfo } from '../../store/reels/reels.action';
import { CLOSE_DIALOGUE } from '../../store/dialogue/dialogue.type';
import { getSetting } from '../../store/setting/setting.action';
import defaultImage from '../../../assets/images/default.jpg';
import { baseURL } from '../../../util/config';
import { getFullImageUrl } from '../../extra/ImageSet';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ImageSliderModal from '../../extra/ImageSliderModal';

const ReelInfoDialogue = () => {
    const dispatch = useDispatch();
    const { dialogueData } = useSelector((state) => state.dialogue);

    const { setting } = useSelector((state) => state.setting);

    const [showFullDesc, setShowFullDesc] = useState(false);
    // Modal state for image slider
    const [showImageModal, setShowImageModal] = useState(false);
    const [activeImageIndex, setActiveImageIndex] = useState(0);

    useEffect(() => {
        dispatch(getSetting());
    }, [dispatch]);

    // Optional: truncate text after approx 4 lines (~300 chars or adjust as needed)
    const truncateLength = 165;

    const description = dialogueData?.description || '';
    const isTruncateNeeded = description.length > truncateLength;

    const displayText = showFullDesc || !isTruncateNeeded
        ? description
        : description.slice(0, truncateLength) + '...';

    const productImages = dialogueData?.products?.map(p => p.mainImage) || [];

    return (
        <>
            <div className="mainDialogue fade-in" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                <div className="DialogueReels" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                    <div className="dialogueHeader">
                        <div className="headerTitle fw-bold">Product Information</div>
                        <div
                            className="closeBtn"
                            onClick={() => {
                                dispatch({ type: CLOSE_DIALOGUE });
                            }}
                        >
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                    </div>

                    <div className='row' style={{ padding: "0px 24px" }}>
                        <div className='col-5'>
                            <div className='model-body mt-3 d-flex justify-content-start'>
                                <video
                                    autoPlay
                                    controls
                                    loop
                                    className="w-100"
                                    height={490}
                                    style={{ borderRadius: "5px" }}
                                    src={dialogueData?.video}
                                    crossOrigin='anonymous'
                                />
                            </div>
                        </div>
                        <div className='col-7'>
                            <div>
                                <h4 className='fw-bold' >{dialogueData?.sellerId?.firstName + ' ' + dialogueData?.sellerId?.lastName}</h4>
                            </div>
                            <div
                                className='row'
                                style={{
                                    maxHeight: '500px',
                                    overflowY: 'auto',
                                    paddingRight: '12px'
                                }}>
                                {dialogueData?.products?.map((data, index) => (
                                    <div
                                        key={index}
                                        className="d-flex mb-4"
                                        style={{
                                            border: "1px solid #eee",
                                            borderRadius: "8px",
                                            padding: "18px",
                                            background: "#fff",
                                            alignItems: "flex-start"
                                        }}

                                    >
                                        <div className='col-4' style={{ minWidth: "180px", marginRight: "18px" }}>
                                            <img
                                                src={data?.mainImage}
                                                alt={data?.productName || "Product image"}
                                                crossOrigin='anonymous'
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = defaultImage;
                                                }}
                                                style={{ width: "80%", borderRadius: "6px", objectFit: "cover", maxHeight: "200px" }}
                                                onClick={() => {
                                                    setActiveImageIndex(index);
                                                    setShowImageModal(true);
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = "scale(1.05)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = "scale(1)";
                                                }}
                                            />
                                        </div>

                                        <div className='col-8'>
                                            <div className='fw-semibold mb-2' style={{ color: "#000" }}>
                                                Product Name : <span style={{ color: "#000", fontWeight: "300" }}>{data?.productName}</span>
                                            </div>
                                            <div className='fw-semibold mb-2' style={{ color: "#000" }}>
                                                Product Code : <span style={{ color: "#000", fontWeight: "300" }}>{data?.productCode}</span>
                                            </div>
                                            <div className='fw-semibold mb-2' style={{ color: "#000" }}>
                                                Product price ({`${setting?.currency?.symbol}`}) : <span style={{ color: "#000", fontWeight: "300" }}>{data?.price}</span>
                                            </div>
                                            {/* Attributes Loop */}
                                            {data?.attributes && data?.attributes.length > 0 && (
                                                <div style={{ marginTop: '12px' }}>
                                                    <div className='fw-semibold' style={{ color: "#000" }}>Attributes:</div>
                                                    {data?.attributes.map((attr, attrIdx) => (
                                                        <div key={attrIdx} style={{ marginBottom: "8px", marginLeft: "12px" }}>
                                                            {/* Attribute Image */}
                                                            {attr?.image && (
                                                                <img
                                                                    src={baseURL + attr.image}
                                                                    alt={attr.name}
                                                                    crossOrigin='anonymous'
                                                                    style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px", marginRight: "10px" }}
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = defaultImage;
                                                                    }}
                                                                />
                                                            )}
                                                            {/* Attribute Name + Values */}
                                                            <span style={{ color: "#444", fontWeight: "bold" }}>{attr?.name}:</span>
                                                            <span style={{ marginLeft: "8px" }}>
                                                                {(attr?.values || []).join(", ")}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>

                    <div
                        style={{
                            background: "#f8f9fa",
                            padding: "10px 28px",
                            borderRadius: "12px",
                            margin: "1px 24px 10px 24px",
                            border: "1px solid #eee",
                            display: "flex",
                            alignItems: "flex-start"
                        }}
                    >
                        <i className="fa-solid fa-info-circle" style={{ fontSize: 26, marginRight: 18, color: "#377dff" }} />
                        <div style={{ fontSize: 16, color: "#343a40", fontWeight: 400 }}>
                            {dialogueData?.description}
                        </div>
                    </div>

                </div>
            </div>



            <ImageSliderModal
                isOpen={showImageModal}
                onClose={() => setShowImageModal(false)}
                images={productImages}
                initialSlide={activeImageIndex}
            />

            
        </>
    );
};

export default ReelInfoDialogue;


